import React from 'react';
import PropTypes from 'prop-types';
import IconHeroCar from '@spothero/icons/hero-car';

import {
    Box,
    Container,
    Flex,
    Grid,
    GridItem,
    Heading,
    Icon,
} from '@spothero/ui';

import {
    homeHeroBackgroundStyleProps,
    HomeHeroHeadlineContainerStyleProps,
    homeHeroH1StyleProps,
    homeHeroH2StyleProps,
    homeHeroIconStyleProps,
    homeHeroIconCircleStyleProps,
    homeHeroSectionStyleProps,
} from './HomeHeroStyleProps';
import TabbedSearchControls from 'pages/home/components/tabbed-search-controls';

const HomeHero = ({backgroundImageURL, pageType, subtitle, title}) => (
    <Box
        data-testid="homeHeroSection"
        _before={{
            // omitting the 'compress,' parameter returns the Prismic Image
            // URL without any compression applied. Typically, we let
            // Prismic's CDN determine the appropriate level of compression
            // for images, but for the hero section of the home page, the
            // uncompressed version is preferred.
            backgroundImage: `url('${backgroundImageURL.replace(
                'compress,',
                ''
            )}')`,
            ...homeHeroBackgroundStyleProps,
        }}
        {...homeHeroSectionStyleProps}
    >
        <Box position="relative">
            <Container>
                <Grid>
                    <GridItem
                        colStart={{base: 0, desktop: 2}}
                        colSpan={{base: 12, desktop: 10}}
                    >
                        <Box
                            marginTop={
                                subtitle
                                    ? {base: 8, tablet: 32}
                                    : {base: 16, tablet: 40}
                            }
                            marginBottom={{base: 16, tablet: 0}}
                        >
                            <Flex
                                as="header"
                                flexDirection="column"
                                alignItems="center"
                            >
                                <Box {...homeHeroIconCircleStyleProps}>
                                    <Icon
                                        as={IconHeroCar}
                                        {...homeHeroIconStyleProps}
                                    />
                                </Box>
                                <Box {...HomeHeroHeadlineContainerStyleProps}>
                                    <Heading {...homeHeroH1StyleProps}>
                                        {title}
                                    </Heading>
                                    {subtitle && (
                                        <Heading {...homeHeroH2StyleProps}>
                                            {subtitle}
                                        </Heading>
                                    )}
                                </Box>
                            </Flex>
                            <TabbedSearchControls pageType={pageType} />
                        </Box>
                    </GridItem>
                </Grid>
            </Container>
        </Box>
    </Box>
);

HomeHero.propTypes = {
    backgroundImageURL: PropTypes.string,
    pageType: PropTypes.string,
    subtitle: PropTypes.string,
    title: PropTypes.string,
};

HomeHero.defaultProps = {
    backgroundImageURL: '../img/home-hero.svg',
    title: `Let's Find Your Spot`,
};

export default HomeHero;
